// Permission for one action of a page (switched per user on the Users page).
//
// `keys` go from the most specific permission to the page's own one, e.g. ("price_list_delete", "cuentas_price_chart_lista",
// "cuentas_price_chart"): the first one the user has a setting for decides, so until someone sets the specific one the
// action simply follows the page (nobody loses anything when a finer permission is introduced). Superusers and staff
// always have everything, like the navigation. The server is not asked: this only hides what the user may not use.
export const isPrivilegedUser = (user) => !!user && (
  user.is_superuser === true || user.is_superuser === "true" ||
  user.is_admin === true || user.is_admin === "true" ||
  user.is_staff === true || user.is_staff === "true" ||
  ["superuser", "admin", "staff"].includes(String(user.role || "").toLowerCase())
);

export function canDo(user, ...keys) {
  if (!user) return false;
  if (isPrivilegedUser(user)) return true;
  const perms = user.nav_permissions || {};
  for (const k of keys) {
    if (perms[k] !== undefined) return !!perms[k];
  }
  return false;
}

// A feature that everyone had before it got a switch (e.g. Modo Oficina): allowed unless it was explicitly switched off for
// that user, so adding the switch does not take it away from anybody.
export const allowedUnlessOff = (user, key) => {
  if (!user) return false;
  if (isPrivilegedUser(user)) return true;
  return (user.nav_permissions || {})[key] !== false;
};
